import { STATUS } from '@/utils/static/kyc';
import { api } from '@/api';

//QUESTS
const getInvestorQuestionnaires = (id) => {
  return api.get('/api/kyc/v1/admin/investor/questionSectionTypes', {
    params: { investorId: id }
  });
};
const deleteInvestorQuestionnaires = (investorId, questionSectionTypeId) => {
  return api.delete('/api/kyc/v1/admin/investor/questionSectionTypes', {
    data: {
      questionSectionTypeId: questionSectionTypeId,
      investorId: investorId
    }
  });
};
const getQuestionnaireAnswers = ({ investorId, questionnaireId }) => {
  return api.get('/api/kyc/v1/admin/investor/questionSectionTypes/answers', {
    params: { investorId: investorId, questionSectionTypeId: questionnaireId }
  });
};
const setQuestionnaireStatus = ({
  investorId,
  status,
  questionnaireId,
  questionId,
  comment = ''
}) => {
  return api.put('/api/kyc/v1/admin/questionnaireSettings', {
    investorId: investorId,
    status: status,
    questionSectionTypeId: questionnaireId,
    questionId: questionId,
    comment: comment
  });
};
const getAllowedQuestsToAdd = ({ investorId }) => {
  return api.get('/api/kyc/v1/admin/questionnaires', { params: { investorId } });
};
const requestQuest = ({ investorId, questId, onlyAdmin }) => {
  return api.post('/api/kyc/v1/admin/questionnaires', {
    investorId: investorId,
    questionSectionTypeId: questId,
    onlyAdmin: onlyAdmin
  });
};
const getRejectedEntities = (investorId) => {
  return api.get('/api/kyc/v1/admin/questionnaire', {
    params: { status: STATUS.REJECTED, investorId }
  });
};
//SUMSUB
const getInvestorSumSubStatus = (id) => {
  return api.get('/api/kyc/v1/admin/verification/investorStatus', {
    params: { investorId: id }
  });
};
const getInvestorSumSubAnswers = (id) => {
  return api.get('/api/kyc/v1/admin/verification/questionnaire', {
    params: { investorId: id }
  });
};
const setInvestorSumSubStatus = ({ investorId, status, questionSectionId }) => {
  return api.put('/api/kyc/v1/admin/verification/investorStatus', {
    investorId: investorId,
    verifiedStatus: status,
    questionSectionId: questionSectionId
  });
};
const getQuestionnaireNotes = ({ investorQuestionSectionTypeId, questionId }) => {
  return api.get('/api/kyc/v1/admin/questionnaire/notes', {
    params: {
      investorQuestionSectionTypeId,
      questionId
    }
  });
};
const addQuestionnaireNote = ({ investorQuestionSectionTypeId, questionId, note }) => {
  return api.post('/api/kyc/v1/admin/questionnaire/notes', {
    investorQuestionSectionTypeId,
    questionId,
    note
  });
};
const updateQuestionnaireNote = ({ noteId, newNote }) => {
  return api.put('/api/kyc/v1/admin/questionnaire/notes', {
    noteId,
    newNote
  });
};
const deleteQuestionnaireNote = ({ noteId }) => {
  return api.delete('/api/kyc/v1/admin/questionnaire/notes', {
    data: { noteId }
  });
};
const getVerificationPhotos = ({ questionSectionId, investorId }) => {
  return api.get('/api/kyc/v1/admin/investor/verification/session/photos', {
    params: {
      questionSectionId,
      investorId
    }
  });
};
const getVerificationPhoto = ({ questionSectionId, mediaId, investorId }) => {
  return api.get('/api/kyc/v1/admin/investor/verification/session/photo', {
    params: {
      questionSectionId,
      mediaId,
      investorId
    }
  });
};
//DOCS
//statuses: ACCEPTED, UNACCEPTED
const getDocumentsSections = (investorId) => {
  return api.get('/api/kyc/v1/admin/questionnaire/document/sections', {
    params: { investorId }
  });
};
const deleteDocument = (investorId, requestDocumentId) => {
  return api.delete('/api/kyc/v1/admin/questionnaire/document/requestDocument', {
    data: {
      investorId: investorId,
      requestDocumentId: requestDocumentId
    }
  });
};
//upload doc
const uploadDocument = ({ requestDocumentId, file, investorId, onlyAdmin }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('requestDocumentId', requestDocumentId);
  formData.append('investorId', investorId);
  formData.append('onlyAdmin', onlyAdmin);

  return api.post('/api/kyc/v1/admin/questionnaire/document', formData);
};
const getDocumentSectionTypes = ({ sectionId, investorId }) => {
  return api.get('/api/kyc/v1/admin/questionnaire/document/types', {
    params: { kycDocumentSectionId: sectionId, investorId: investorId }
  });
};
const addDocumentRequest = ({ docTypeId, investorId, onlyAdmin }) => {
  return api.post('/api/kyc/v1/admin/questionnaire/document/requestDocument', {
    kycTypeDocumentId: docTypeId,
    onlyAdmin,
    investorId
  });
};
const getDocumentRequests = (investorId) => {
  return api.get('/api/kyc/v1/admin/questionnaire/document/requestDocuments', {
    params: { investorId }
  });
};
const getQuestsDocuments = (investorId) => {
  return api.get('/api/kyc/v1/admin/questionnaire/document/documentAnswers', {
    params: { investorId }
  });
};
const getDocumentRequest = ({ investorId, requestId }) => {
  return api.get('/api/kyc/v1/admin/questionnaire/document/requestDocument', {
    params: { investorId, requestDocumentId: requestId }
  });
};
const updateRequestStatus = ({ kycDocumentId, status }) => {
  //STATUSES: [ACCEPTED, UNACCEPTED]
  return api.put('/api/kyc/v1/admin/questionnaire/document', { kycDocumentId, status });
};
const addRequestComment = ({ kycDocumentId, comment }) => {
  return api.post('/api/kyc/v1/admin/questionnaire/document/comment', {
    kycDocumentId,
    comment
  });
};

//DEEP CHECK
const getInvestorDeepCheck = (investorId) => {
  return api.get('/api/kyc/v1/admin/checkInvestor', { params: { investorId } });
};
/**
 * @param investorId
 * @param type: FULL_KYC, SANCTIONS
 * @returns {Promise<AxiosResponse<T>>}
 */
const initInvestorDeepCheck = ({ investorId, type }) => {
  return api.post('/api/kyc/v1/admin/checkInvestor', { investorId, type });
};

const setInvestorStatus = (data) => {
  return api.put('/api/kyc/v1/admin/investor/accountStatus', data);
};

const getInvestorProducts = (id) => {
  return api.get('/api/kyc/v1/admin/investor/products/my', {
    params: { investorId: id }
  });
};
const getProductAnswers = ({ investorId, investorProductId }) => {
  return api.get('/api/kyc/v1/admin/investor/products/questions', {
    params: { investorId, investorProductId }
  });
};
const setProductStatus = ({ investorId, status, productId, questionId, comment = '' }) => {
  return api.put('/api/kyc/v1/admin/products/status', {
    investorId: investorId,
    status: status,
    investorProductId: productId,
    productQuestionId: questionId,
    comment: comment
  });
};
const getProductRejectedEntities = (investorId) => {
  return api.get('/api/kyc/v1/admin/investor/products/questions/status', {
    params: { status: STATUS.REJECTED, investorId }
  });
};
const getAllowedProductsToAdd = ({ investorId }) => {
  return api.get('/api/kyc/v1/admin/investor/products', { params: { investorId } });
};
const requestProduct = ({ investorId, productId, onlyAdmin }) => {
  return api.post('/api/kyc/v1/admin/investor/products', {
    investorId: investorId,
    productId: productId,
    onlyAdmin: onlyAdmin
  });
};
const sendProductContractNumber = ({ investorId, investorProductId, numberContract }) => {
  return api.put('/api/kyc/v1/admin/products/numberContract', {
    investorId: investorId,
    investorProductId: investorProductId,
    numberContract: numberContract
  });
};

export const adminKYCApi = {
  getInvestorDeepCheck,
  initInvestorDeepCheck,
  getInvestorQuestionnaires,
  getQuestionnaireAnswers,
  setQuestionnaireStatus,
  getAllowedQuestsToAdd,
  requestQuest,
  getRejectedEntities,
  getInvestorSumSubStatus,
  getInvestorSumSubAnswers,
  setInvestorSumSubStatus,
  getDocumentsSections,
  getDocumentSectionTypes,
  uploadDocument,
  addDocumentRequest,
  getDocumentRequests,
  getQuestsDocuments,
  getDocumentRequest,
  updateRequestStatus,
  addRequestComment,
  setInvestorStatus,
  getInvestorProducts,
  getProductAnswers,
  setProductStatus,
  getProductRejectedEntities,
  getAllowedProductsToAdd,
  deleteInvestorQuestionnaires,
  requestProduct,
  deleteDocument,
  sendProductContractNumber,
  getQuestionnaireNotes,
  addQuestionnaireNote,
  updateQuestionnaireNote,
  deleteQuestionnaireNote,
  getVerificationPhotos,
  getVerificationPhoto
};
